import MaskedInput, { MaskedInputProps } from "react-text-mask";
import { ITextFieldProps, TextField } from "./TextField";

// @ts-ignore
interface IProps extends ITextFieldProps, MaskedInputProps {}

const MaskedTextField = ({ ...props }: IProps) => {
  return <TextField as={MaskedInput} {...props} />;
};

export { MaskedTextField };
